import { motion } from "framer-motion";
import { Play } from "lucide-react";
import Image from "next/image";
export function MediaCard({ item, onClick }) {
    return (
        <motion.div
            className="relative group cursor-pointer overflow-hidden bg-neutral-100 h-full w-full"
            onClick={onClick}
            whileHover={{ y: -2 }}
            transition={{ duration: 0.3 }}
        >
            <div className="relative w-full h-full overflow-hidden">


                <Image
                src={item.type === "video" ? item.thumbnail : item.url}
                alt={item.caption || "Media image"}
                fill
                className="object-cover transition-transform duration-700 group-hover:scale-110"
                sizes="(max-width: 768px) 100vw, 50vw"
                />

                {item.type === "video" && (
                    <div className="absolute inset-0 flex items-center justify-center">
                        <motion.div
                            className="bg-white/95 backdrop-blur-sm rounded-full p-2.5 transition-all duration-300 group-hover:bg-orange-500 shadow-lg"
                            whileHover={{ scale: 1.15 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <Play className="w-5 h-5 text-orange-500 group-hover:text-white fill-current" />
                        </motion.div>
                    </div>
                )}
            </div>
        </motion.div>
    );
}
